import { ChangeEvent } from "react";

import { Form, Input, Tooltip } from "antd";

import addFileIcon from "data/icons/add-file.svg";
import attachedFileIcon from "data/icons/attached-file.svg";
import closeIcon from "data/icons/close.svg";
import exclamationRedIcon from "data/icons/exclamation-circle-red.svg";
import { Loading } from "components/common";

interface IProps {
  files: any[];
  setFiles: (files: any[]) => void;
  filesUploadStatus: string[];
  onUploadFile: (file: File ) => void;
  onRemoveFile: (index: number) => void;
  filesErrors: {
    fileName: string;
    error: boolean;
  }[];
}

const CaseFilesField = ({
  files,
  setFiles,
  filesUploadStatus,
  onUploadFile,
  onRemoveFile,
  filesErrors,
}: IProps) => {
  const onInputFile = (e: ChangeEvent<HTMLInputElement>) => {
    let result: File[] = [];

    e.target.files && Object.keys(e.target.files).forEach((label) => {
      result.push(e.target.files![ +label ])
    });

    result.forEach(onUploadFile);
    setFiles([ ...files, ...result ]);

    // @ts-ignore
    // e.target.value = null;
  };

  return (
    <>
      <Form.Item
        label={
          <>
            Problem Description
            <label className="add-file-label">
              <img
                alt=""
                src={ addFileIcon }
                style={ { marginRight: "5px" } }
              />

              Add file (up to 10Mb)

              <input
                type="file"
                style={ { display: "none" } }
                multiple
                onChange={ onInputFile }
              />
            </label>
          </>
        }
        name="text"
        className="form-with-button"
      >
        <Input.TextArea
          style={ { resize: "none", height: 116 } }
          placeholder="Add problem description"
        />
        {/*<div*/ }
        {/*	{ ...getRootProps() }*/ }
        {/*	className={ isDragActive ? "file-dropzone" : "" }*/ }
        {/*	onClick={ () => {*/ }
        {/*	} }*/ }
        {/*>*/ }
        {/*	/!*<input { ...getInputProps() } />*!/*/ }
        {/*	{isDragActive*/ }
        {/*		? <p>Drop the files here...</p>*/ }
        {/*		: <Input.TextArea*/ }
        {/*			style={ { resize: "none", height: "58px" } }*/ }
        {/*		/>*/ }
        {/*	}*/ }
        {/*</div>*/ }
      </Form.Item>

      <div className="files-list">
        { files.map((file, index) => (
          <div
            key={ file.name }
            className="files-item"
          >
            <img
              alt=""
              src={ attachedFileIcon }
            />

            { file.name }

            <div className="cross-file">
              <Loading isLoading={ filesUploadStatus.includes(file.name) }/>

              {filesErrors.find(({ fileName }) => fileName === file.name) && (
                <Tooltip title="Uploading error">
                  <div>
                    <img
                      alt=""
                      src={ exclamationRedIcon }
                    />
                  </div>
                </Tooltip>
              )}

              <div
                onClick={ () => onRemoveFile(index) }
                className="cross-file-close"
              >
                <img src={ closeIcon } alt=""/>
              </div>
            </div>
          </div>
        )) }
      </div>
    </>
  );
};

export default CaseFilesField;
